var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0854 4.9668C17.2183 4.86719 17.4175 4.9668 17.4175 5.13281V11.9062C17.4175 12.8027 16.687 13.5 15.8237 13.5H2.01123C1.11475 13.5 0.41748 12.8027 0.41748 11.9062V5.13281C0.41748 4.9668 0.583496 4.86719 0.716309 4.9668C1.47998 5.56445 2.44287 6.29492 5.82959 8.75195C6.52686 9.25 7.72217 10.3457 8.91748 10.3457C10.0796 10.3457 11.3081 9.25 11.9722 8.75195C15.3589 6.29492 16.3218 5.56445 17.0854 4.9668ZM8.91748 9.25C8.12061 9.2832 7.0249 8.28711 6.46045 7.88867C2.04443 4.70117 1.7124 4.40234 0.716309 3.60547C0.51709 3.47266 0.41748 3.24023 0.41748 2.97461V2.34375C0.41748 1.48047 1.11475 0.75 2.01123 0.75H15.8237C16.687 0.75 17.4175 1.48047 17.4175 2.34375V2.97461C17.4175 3.24023 17.2847 3.47266 17.0854 3.60547C16.0894 4.40234 15.7573 4.70117 11.3413 7.88867C10.7769 8.28711 9.68115 9.2832 8.91748 9.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.7bb55d1ac442707421988c104a5116de.svg";
export { ForwardRef as ReactComponent };